<template>
    <div class="asideview-adwords-ads" v-if="hasLoaded">
        <div class="row">
            <div class="col-lg-12" style="margin-bottom: 20px;">
                <i class="fa fa-google" style="display: inline; float: left; margin-right: 10px;"/>
                <h6>{{$t('overview.quickview.adWords.headline')}}</h6>
                <p>{{$t('overview.quickview.adWords.description')}}</p>
            </div>

            <div class="col-lg-3 text-center value-col">
                <strong>{{$t('overview.quickview.adWords.reach')}}</strong><br />
                {{values.impressions | numberFormat}}
            </div>

            <div class="col-lg-3 text-center value-col">
                <strong>{{$t('overview.quickview.adWords.clicks')}}</strong><br />
                {{values.clicks | numberFormat}}
            </div>

            <div class="col-lg-3 text-center value-col">
                <strong>{{$t('overview.quickview.adWords.conversions')}}</strong>
                <br />
                {{values.conversions}}
            </div>

            <div class="col-lg-3 text-center value-col">
                <strong>{{$t('overview.quickview.adWords.cost')}}</strong><br />
                {{(values.cost  / 1000000) | fixedNumber(2) | numberFormat}} {{$t('overview.quickview.adWords.affix')}}
            </div>
        </div>

        <div class="row bottom-row">
            <div class="col-lg-12">
                <quickview-range :from="from" :to="to" :cta="cta" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~@/assets/scss/_mixins.scss';

    .value-col {
        @include ellipsis;
    }
</style>

<script>
    import QuickviewRange from '@/app/layout/components/QuickviewRange'

    const AdWordsService = require('@/services/google-adwords/GoogleAdWordsService')

    import hasIntegration from '@/mixins/integrations/hasIntegration'

    const moment = require('moment')

    export default {
        mixins: [hasIntegration],

        data() {
            return {
                from: moment().subtract(7, 'days'),
                to: moment().startOf('day'),
                values: null,
                cta: {
                    label: $t('overview.quickview.adWords.cta'),
                    link: {
                        name: 'frontend.google.adwords'
                    }
                }
            }
        },

        computed: {
            hasLoaded() {
                return this.values && Object.keys(this.values).length
            }
        },

        mounted() {
            this.$emit('state', 'loading')

            if (!this.hasHealthyIntegration('Google adwords')) {
                this.$emit('state', 'failed')
                return
            }

            this.load()
        },

        methods: {
            load() {
                AdWordsService.accountPerformance(this.from, this.to, {}, response => {
                        const body = response.data
                        const attributes = body.accountPerformance.row['@attributes']

                        if (!Object.keys(attributes).length) {
                            this.$emit('state', 'failed')
                            return
                        }

                        const insights = {
                            impressions: attributes.impressions,
                            clicks: attributes.clicks,
                            conversions: attributes.ctr,
                            cost: attributes.cost
                        }

                        this.values = insights

                        this.$emit('state', 'success')
                    }, error => {
                        this.$emit('state', 'failed')
                    }
                )
            }
        },

        components: {
            QuickviewRange
        }
    }
</script>
